import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class EstateLiquidationProgress extends BaseModel {
  /**
   * @var {number}
   */
  estateAccountBalance;

  /**
   * @var {number}
   */
  assetsPending;

  /**
   * @var {number}
   */
  liabilitiesPending;

  /**
   * @var {number}
   */
  gainLosses;

  /**
   * @var {string}
   */
  date;

  constructor(model = {}) {
    super();
    this.estateAccountBalance = model.estateAccountBalance;
    this.assetsPending = model.assetsPending;
    this.liabilitiesPending = model.liabilitiesPending;
    this.gainLosses = model.gainLosses;
    this.date = model.date;
  }
}
